// extracted by mini-css-extract-plugin
export default {"body":"Login_body__vL-xD"};